<style scoped>
</style>

<style scoped>
@import "https://fonts.googleapis.com/icon?family=Material+Icons";
@import "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined";

::placeholder {
  color: #fff !important;
  opacity: 1; /* Firefox */
}
.logo-placeholder {
  box-shadow: none !important;
}
.sshi-icon {
  padding: 0.5rem;
  max-width: 120px;
  max-height: 120px;
  width: auto;
  height: auto;
}
.sshi-logo {
  padding: 0.5rem;
  max-width: 80px;
  max-height: 80px;
  width: auto;
  height: auto;
}

.sshi-logo2 {
  margin: 0.25rem;
  border-radius: 50% !important;
  /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */
}

.sshi-logo3 {
  margin-left: 4rem;
  margin-right: 4rem;
  border-radius: 50% !important;
  /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */
}

.sshi-banner {
  margin-bottom: 0px;
  padding-top: 5em;
  background-image: url("/img/sshi/bg-scenery.webp");
  text-align: center;
  min-height: 25em;
}
.sshi-text {
  color: #fff !important;
}
.yellow-line {
  margin-left: 30%;
  margin-right: 30%;
  background-color: #ffdf12;
  height: 5px;
  border-radius: 20px;
}
.overlap-header {
  margin-top: -10em;
}
.slide-root {
  margin-top: -7em;
  padding-left: 7em;
  padding-right: 7em;
}
.slide-bag {
  /* margin-left: 1em;
  margin-right: 1em; */
  /* max-width: 200px; */
  border-radius: 1em;
  padding: 0em;
  background-color: white;
  /* max-height: 250px; */
  color: rgb(0, 60, 128);
}
.slide-arrow {
  background-color: #ffff;
  border-radius: 100%;
  padding-top: 1.2em;
  padding-bottom: 2.2em;
  color: rgb(0, 147, 221);
}
</style>
<template>
  <b-container
    fluid
    style="
      width: 100%;
      padding-bottom: 5%;
      font-family: 'Inter', 'sans-serif' !important;
      padding-left: 0px;
      padding-right: 0px;
    "
  >
    <b-jumbotron class="sshi-banner text-center">
      <h1 class="sshi-text" style="margin-bottom: 0px !important">
        Editor Berita
      </h1>
    </b-jumbotron>
    <b-row class="overlap-header ml-5 mr-5">
      <b-col class="ml-5 mr-5">
        <div
          style="
            background-color: white;
            padding: 3em 5em 3em 5em;
            border-radius: 1em;
            text-align: justify;
          "
        >
          <!-- Form untuk Judul -->
          <b-form-group label="Judul" label-for="title" class="mb-3">
            <b-form-input
              id="title"
              v-model="form.title"
              placeholder="Masukkan judul konten"
              required
            />
          </b-form-group>

          <!-- Form untuk Thumbnail -->
          <b-form-group
            label="Thumbnail"
            label-for="thumbnail"
            description="URL gambar untuk thumbnail konten."
            class="mb-3"
          >
            <b-form-input
              id="thumbnail"
              v-model="form.thumbnail"
              placeholder="Masukkan URL thumbnail"
            />
          </b-form-group>

          <!-- Preview Thumbnail -->
          <b-card
            v-if="form.thumbnail"
            class="mb-4"
            img-src="form.thumbnail"
            img-alt="Thumbnail Preview"
            img-top
          >
            <b-card-text>Preview Thumbnail</b-card-text>
          </b-card>
          <div v-else class="text-muted mb-4">
            Thumbnail akan muncul di sini.
          </div>

          <!-- Editor Konten -->
          <b-form-group label="Konten" label-for="content-editor" class="mb-4">
            <vue-editor id="content-editor" v-model="form.content" />
          </b-form-group>

          <!-- Tombol Aksi -->
          <div class="d-flex justify-content-end">
            <b-button variant="primary" class="mr-2" @click="saveContent"
              >Simpan</b-button
            >
            <b-button variant="secondary" @click="cancelEdit">Batal</b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { VueEditor } from "vue2-editor";
export default {
  name: "sshi-news-manajemen",
  components: { VueEditor },
  data() {
    return {
      form: {
        title: "",
        thumbnail: "",
        content: "",
      },
      ceklogin: false,
    };
  },
  created() {},
  mounted() {
    this.cekLogin();
  },
  setup() {},
  methods: {
    saveContent() {
      // Logika untuk menyimpan konten
      console.log(JSON.stringify(this.form, null, 2));
      //   alert("Konten berhasil disimpan:\n" + JSON.stringify(this.form, null, 2));
    },
    cancelEdit() {
      // Logika untuk membatalkan perubahan
      if (confirm("Apakah Anda yakin ingin membatalkan perubahan?")) {
        this.form = { title: "", thumbnail: "", content: "" };
      }
    },
    editContent(index) {
      // Logika untuk edit konten
      alert(`Edit konten dengan index ${index}`);
    },
    deleteContent(index) {
      // Logika untuk delete konten
      if (confirm("Apakah Anda yakin ingin menghapus konten ini?")) {
        this.contents.splice(index, 1);
        alert("Konten berhasil dihapus");
      }
    },
    cekLogin() {
      let status = JSON.parse(localStorage.getItem("vuex"));
      if (status.auth.status == 0 || status == "") {
        this.ceklogin = true;
      }
      console.log(status);
    },
    keLogin() {
      window.location.href = "/login";
    },
  },
};
</script>




<style scoped>
/* Tambahkan styling khusus di sini jika diperlukan */
</style>